import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { addOpacityToHex } from '@/utils';

export const VIEW_ORDER_BAR_HEIGHT = 60;

/** Far enough below the screen edge to clear the bar, its offset and the inset. */
export const HIDDEN_OFFSET = 200;

export const styles = StyleSheet.create((colors, rt) => ({
  absolute: {
    left: 0,
    position: 'absolute',
    paddingHorizontal: theme.spacing[2],
    bottom: theme.spacing[2],
    width: Math.min(rt.screen.width, theme.breakpoints.tablet),
  },
  container: {
    bottom: theme.spacing[4] + rt.insets.bottom,
    minHeight: VIEW_ORDER_BAR_HEIGHT,
    marginHorizontal: theme.spacing[2],
    borderRadius: theme.borderRadius.m,
    backgroundColor: colors.cartBarBackground,
    shadowColor: colors.backgroundL1,
    elevation: 8,
    shadowRadius: 8,
    shadowOpacity: 0.1,
    shadowOffset: {
      width: 0,
      height: -2,
    },
  },
  cookieConsent: {
    width: '100%',
  },
  content: {
    flex: 1,
    height: VIEW_ORDER_BAR_HEIGHT,
    // maxWidth: rt.screen.width - theme.spacing[4] * 2,
    paddingHorizontal: theme.spacing[5],
    paddingVertical: theme.spacing[5],
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    alignSelf: 'center',
    _web: {
      width: '100%',
    },
  },
  leftSection: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  orderSummary: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[4],
    justifyContent: 'center',
  },
  viewOrderText: {
    flex: 1,
  },
  guestsCountCard: {
    width: 32,
    aspectRatio: 1,
    borderRadius: theme.borderRadius.xs,
    paddingHorizontal: theme.spacing[4],
    backgroundColor: colors.borderInverse,
    alignItems: 'center',
    justifyContent: 'center',
  },
  promoIconContainer: {
    width: 26,
    height: 26,
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: theme.borderRadius.full,
    backgroundColor: addOpacityToHex(colors.iconPositive, 0.4),
  },
}));
